module.exports = {"340372006":"胜利街道","340372007":"龙湖新村街道","340372008":"湖滨社区行政事务管理中心","340372009":"淮河社区行政事务管理中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340372.json
// module id = 1065
// module chunks = 0